'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPartnerInClientPortalSelector = exports.isPartnerProgramEligibleSelector = undefined;

var _Scopes = require('pricing-pages-unified-ui/constants/Scopes');

var isPartnerProgramEligibleSelector = exports.isPartnerProgramEligibleSelector = function isPartnerProgramEligibleSelector(_ref) {
  var auth = _ref.auth;
  var user = auth.user;

  if (!user) return false;

  var scopes = user.scopes;

  if (!scopes) return false;

  var isDirectoryUser = scopes.some(function (scope) {
    return scope === _Scopes.DIRECTORY_USER;
  });
  var isPartner = scopes.some(function (scope) {
    return scope === _Scopes.PARTNER_LEAD_REGISTRATION;
  });

  return isDirectoryUser && !isPartner;
};

var isPartnerInClientPortalSelector = exports.isPartnerInClientPortalSelector = function isPartnerInClientPortalSelector(_ref2) {
  var auth = _ref2.auth,
      usersInPortal = _ref2.usersInPortal;

  var activeUserId = auth.user.user_id;
  var users = usersInPortal.users;

  if (!users) {
    return false;
  }
  var userInfo = users.find(function (user) {
    return user.id === activeUserId;
  });
  return userInfo.partner;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/PartnerProgramSelectors.js
// module id = 370
// module chunks = 3 4 5